import { uiText } from '../../i18n';
/** Telegram can return an empty surname or a punctuation placeholder. */
export function accountName(user: { first_name?: string | null; last_name?: string | null }) {
  const part = (value: string | null | undefined) => /^[\s\-–—.]*$/.test(value || '') ? '' : value!.trim();
  const first = part(user.first_name);
  const last = part(user.last_name);
  return {
    first,
    last,
    name: [first, last].filter(Boolean).join(' ') || uiText('Без имени'),
    initials: (Array.from(first)[0] || '') + (Array.from(last)[0] || '') || '?',
  };
}
